import styled from 'styled-components';
import { TextButton } from '@amzn/storm-ui';
import { StyledComponentsPropWithTheme } from '../../../../commons/components/ChromeApp/ChromeAppUtils';

export const FocusHeaderWrapper = styled.div`
  box-sizing: border-box;
  min-height: 76px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 20px;
  background-color: ${(props: StyledComponentsPropWithTheme) =>
    props.theme.header.pageHeader.background};
  box-shadow: 0px 1px 2px 0px rgba(17, 17, 17, 0.3);
`;

export const FocusHeaderSpacer = styled.div`
  height: ${({ theme }) => theme.spacing.mini};
`;

export const FocusHeaderSection = styled.div`
  display: flex;
  align-items: center;
`;

export const HeadingArea = styled.div`
  margin: 0 0 0 25px;
  display: inline-block;
`;

export const PageTitle = styled.h2`
  font-size: 18px;
  font-weight: normal;
  color: #0b0b0b;
  margin: 0;
`;

export const Close = styled(TextButton)`
  &&& {
    color: ${({ theme }) => theme.palette.inkwell};
  }
`;
